// Creates the Vue application instance and registers all global plugins.
// Returns the app so the bootstrap pipeline can mount it after all init
// steps have run. Router is exported separately for initSentry (needs it
// before the app mounts).

import { createApp, type App as VueApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import * as Sentry from '@sentry/vue'
import VueTelInput from 'vue-tel-input'

import App from '@app/App.vue'
import router from '@app/router'
import { queryClient } from '@core/query/queryClient'
import '@shared/adapters/chartjs'
import SlicealPreset from '@uiKit/theme/slicealPreset'
import '@uiKit/theme/fonts.css'
import '@uiKit/theme/main.css'
import '@uiKit/theme/common.css'

export const createAppInstance = (): VueApp => {
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  pinia.use(Sentry.createSentryPiniaPlugin())
  app.use(router)
  app.use(VueQueryPlugin, { queryClient })
  app.use(ToastService)
  app.use(ConfirmationService)
  app.use(VueTelInput)
  app.use(PrimeVue, {
    theme: {
      preset: SlicealPreset,
      options: {
        prefix: 'p',
        darkModeSelector: '.p-dark',
        cssLayer: false,
      },
    },
  })
  app.directive('tooltip', Tooltip)

  return app
}

export { router }
